/**
 * Returns a boolean representing if the provided `value` is an object.
 */
export const isObject = (value: unknown): value is object => {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};
